import React,{ Component, createContext} from "react";

export const AuthContext = createContext({});

export default class AuthProvider extends Component{
    constructor(props){
        super(props);
        const auth = JSON.parse(sessionStorage.getItem("auth"));
        this.state = {
            auth:auth,
            signIn:this.signIn
        }
    }

    signIn = (auth)=>{
        //write auth to session storage
        sessionStorage.setItem("auth", JSON.stringify(auth))
        this.setState({auth:auth})
    } 

    signOut = ()=>{
        //Delete auth from session
        sessionStorage.removeItem("auth")
        this.setState({auth:{}})
    }

    render(){
        return(<AuthContext.Provider value={{
            auth:this.state.auth, 
            signIn:this.signIn,
            signOut:this.signOut
        }}>{this.props.children}</AuthContext.Provider>)
    }
}


// WEBPACK FOOTER //
// ./src/providers/Auth/AuthProvider.jsx